
    var React = require('react');
    var createReactClass = require('create-react-class');
    var PageRenderer = require('catalog').PageRenderer;
    if (PageRenderer.__esModule) {
      PageRenderer = PageRenderer.default;
    }
    var WrappedPageRenderer = createReactClass({
      displayName: 'WrappedPageRenderer',
      getInitialState: function() {
        return {content: require("!!../../node_modules/raw-loader/index.js!./toggle.md")};
      },
      componentWillMount: function() {
        var component = this;
        if (module.hot) {
          module.hot.accept("!!../../node_modules/raw-loader/index.js!./toggle.md", function() {
            component.setState({
              content: require("!!../../node_modules/raw-loader/index.js!./toggle.md")
            })
          })
        }
      },
      render: function() {
        return React.createElement(PageRenderer, Object.assign({}, this.props, {content: this.state.content}));
      }
    });
    WrappedPageRenderer.__catalog_loader__ = true;
    module.exports = WrappedPageRenderer;
  


//////////////////
// WEBPACK FOOTER
// ./catalog/pages/toggle.md
// module id = 795
// module chunks = 1